module.exports = __webpack_public_path__ + "static/media/golomt.6d6a5422.png";